/**
 * Created by shaun on 16/09/2017.
 */

import Vue from 'vue';

import {EMPTY, READY, LOADING, UPDATING, ERROR, WORKFLOW_STATE_ONGOING} from 'module/constants';
import common from 'module/common';
import {mapFieldMutation} from 'module/mapField';
import Moment from "moment/moment";

const SET_SELECTED_STATE = 'selectedState';
const SET_SELECTED_RAW_ESTIMATE = 'selectedRawEstimate';

// initial state
const state = {
  selected: {
    state: EMPTY,
    stateByAction: {},
    rawEstimate: null
  },
  saving: {}
};

//actions
const actions = {
  select({commit, dispatch, rootGetters}, rawEstimate) {
    return new Promise((resolve, reject) => {
      if (quote._refresh === true) {
        commit(SET_SELECTED_STATE, UPDATING);
      } else {
        commit(CLEAR_ACTION_STATES);
        commit(SET_SELECTED_STATE, LOADING);
      }

      common
        .httpPost('rawEstimate')
        .data({action: 'get', rawEstimate: quote._id, ref: quote.ref, idToken: rootGetters['user/idToken']()})
        .then((res) => {
          if (quote._searchStore) {
            // res.data._searchStore = quote._searchStore;
          }

          //Select brand for project
          dispatch('brand/selectBrand', res.data.brand.name, {root: true});

          dispatch('selectQuoteUsingProject', res.data);

          if (state.selected.plot) {
            //Load update the selected plot
            dispatch('selectPlot', state.selected.plot);
          }

          resolve(res.data);
        }, (error) => {
          console.log('Error', error);
          dispatch('error/error', error, {root: true});
          commit(SET_SELECTED_STATE, ERROR);
          reject();
        });
    });
  },
  refresh({state, dispatch}) {
    if (state.selected.state === READY && state.selected.rawEstimate !== null) {
      dispatch('select', {
        _id: state.selected.rawEstimate._id,
        _refresh: true
      });
    }
  },
  assignTo({commit, dispatch}, {quote, workflow, workflowId, user, step, plotId, workSection}) {
    dispatch('save', {
      quote,
      label: 'Assign Quote',
      action: 'assignTo',
      data: {
        workflow,
        workflowId,
        user,
        step,
        plotId,
        workSection
      }
    });
  },
  save({commit, dispatch, state, rootState, rootGetters}, {rawEstimate, label, action, actions, data}) {
    return new Promise((resolve, reject) => {

      dispatch('error/clear', null, {root: true});
      data = _.merge({
        rawEstimateId: rawEstimate._id,
        idToken: rootGetters['user/idToken'](),
        action,
        actions
      }, data);



      if (state.selected.rawEstimate !== null && state.selected.rawEstimate._id && quote._id) {
        commit(SET_SELECTED_STATE, UPDATING);
      }

      common
        .httpPost('rawEstimate')
        .data(data)
        .then((res) => {
          let data = res.data;

          commit(UPDATE_LAST_SAVED, data);

          if (quote._searchStore && data.rawEstimateAs.search === null) {
            dispatch(rawEstimate._searchStore + '/removeRow', quote, {root: true});
          } else if (rawEstimate._searchStore) {
            dispatch(rawEstimate._searchStore + '/updateRow', {
              rowId: rawEstimate._searchStoreRowId || null,
              rowToUpdate: data.rawEstimateAs.search
            }, {root: true});
          }

          if (state.selected.rawEstimate !== null && state.selected.rawEstimate._id && rawEstimate._id) {
            commit(SET_SELECTED_STATE, READY);
            commit(SET_SELECTED_RAW_ESTIMATE, data.rawEstimate);
          }
          resolve(data);
        }, (error) => {
          console.log('Error', data.label, data, error);
          dispatch('error/error', error, {root: true});
          if (state.selected.rawEstimate !== null && state.selected.rawEstimate._id && rawEstimate._id) {
            commit(SET_SELECTED_STATE, ERROR);
          }
          reject();
        });
    });
  }
};

//getters
const getters = {

};

// mutations
const mutations = {
  [SET_SELECTED_STATE](state, newState) {
    state.selected.state = newState;
  },
  [SET_SELECTED_RAW_ESTIMATE](state, quote) {
    state.selected.quote = quote;
  }
};

export default {
  state,
  actions,
  getters,
  mutations
}